<template>
  <upload-statutory-modal
    ref="uploadDocumentModal"
    :data-edit="dataEdit"
    :source-id="dataEdit.sourceId"
    :documents-list="documentsList"
    :documents-headers="documentsHeaders"
    v-on="$listeners"
  />
</template>

<script>
import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import UploadStatutoryModal from '@/components/Upload/UploadStatutoryModal.vue'
export default {
  name: 'StatutoryDocuments',
  components: { UploadStatutoryModal },
  mixins: [filesValidateMixinChildActions],
  props: {
    contragent: {
      type: Object,
      default: () => ({}),
    },
    documentsList: {
      type: Object,
      default: () => ({}),
    },
    documentsHeaders: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataEdit: {
        sourceModelName: 'contragents',
        sourceId: 0,
        documentType: 'statutory',
      },
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'уставные документы',
        childFilesCountProperty: 'countFiles',
      },
    }
  },
  watch: {
    contragent: {
      immediate: true,
      handler(newVal) {
        this.dataEdit.sourceId = newVal.id
      },
    },
  },
}
</script>
